import { type ReactNode } from "react";
import Link from "next/link";

interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  isBooking?: boolean;
  target?: string;
  variant?: 'primary' | 'secondary' | 'whitePrimary' | 'whiteSecondary' | 'highlight' | 'default';
  className?: string;
}

export function Button({ 
  children, 
  href, 
  isBooking = false,
  target,
  variant = 'default',
  className = ''
}: ButtonProps): JSX.Element {
  const baseClasses = `border-solid border gap-4 px-9 py-4 text-xs text-center font-display tracking-[0.25em] uppercase transition duration-500 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-highlight-500 w-auto min-w-[215px] max-w-60 rounded-se-[0.75em] rounded-es-[0.75em] ${className}`;
  
  const variantStyles = {
    whitePrimary: "border-white text-white hover:bg-primary-700 hover:border-primary-700 hover:text-white w-full",
    whiteSecondary: "border-white text-white hover:bg-highlight-500 hover:border-highlight-500 hover:text-white px-7 py-3 w-full",
    primary: "border-primary-500 text-white hover:bg-white hover:text-primary-500 bg-primary-500",
    secondary: "border-highlight-500 text-white hover:bg-white hover:text-highlight-500 bg-highlight-500",
    highlight: "border-highlight-500 text-white hover:bg-white hover:text-highlight-500 bg-highlight-500",
    default: "border-gray-500 text-gray-500 hover:bg-gray-500" //hover:text-white
  };

  const buttonClasses = `${baseClasses} ${variantStyles[variant]} ${isBooking ? 'junglebee-widget-book-now-button' : ''}`;

  const buttonProps = {
    className: buttonClasses,
    ...(isBooking && { 'data-junglebee-widget-id': 'RQSm3iQUoZ' }),
    ...(target && { target, rel: 'noopener noreferrer' })
  };

  if (href) {
    return (
      <a href={href} {...buttonProps}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" {...buttonProps}>
      {children}
    </button>
  );
} 